export const LANGUAGES = [
  { value: 'javascript', name: 'Javascript' },
  { value: 'python', name: 'Python' },
  { value: 'text/x-java', name: 'Java' },
  { value: 'text/x-c++src', name: 'C++' },
  { value: 'application/x-ejs', name: 'HTML' },
  { value: 'css', name: 'CSS' }
]

const CONFIG = {}

export default {
  LANGUAGES,
  CONFIG
}
